import DeprecatedComponentPanel from './deprecatedComponentPanel/deprecatedComponentPanel';

export * as constants from './constants';

export { DeprecationOverlayEntryPoint } from './scope';

export const panels = {
  deprecatedComponentPanel: DeprecatedComponentPanel,
};
